import React from 'react';
import { Play, FileText, Calculator, Search, CheckCircle2, ArrowRight } from 'lucide-react';
import WhatsAppActivation from './WhatsAppActivation';

const Onboarding = () => {
  const steps = [
    {
      title: "Bem-vindo ao ImóvelIA",
      description: "Vamos te ajudar a começar! Siga este guia rápido para aproveitar ao máximo nossa ferramenta.",
      video: "https://www.youtube.com/embed/eKOEkYX4jSE",
      action: {
        text: "Assistir Tutorial Completo",
        icon: <Play className="h-5 w-5" />
      }
    },
    {
      title: "Análise de Documentos",
      description: "Envie editais e matrículas para análise automática. Nossa IA identifica riscos e oportunidades.",
      icon: <FileText className="h-8 w-8 text-blue-600" />,
      link: "/app/analysis"
    },
    {
      title: "Calculadora de Viabilidade",
      description: "Calcule custos, retorno e viabilidade de qualquer imóvel em leilão.",
      icon: <Calculator className="h-8 w-8 text-blue-600" />,
      link: "/app/calculator"
    },
    {
      title: "Busca Inteligente",
      description: "Encontre imóveis com os filtros que você precisa: desconto, localização, tipo e mais.",
      icon: <Search className="h-8 w-8 text-blue-600" />,
      link: "/app"
    }
  ];

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-xl shadow-lg border border-slate-100 overflow-hidden">
        <div className="p-6 bg-blue-50 border-b border-blue-100">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-6 w-6 text-blue-600" />
            <h2 className="text-xl font-semibold text-slate-900">
              Primeiros Passos
            </h2>
          </div>
        </div>

        {/* WhatsApp Activation */}
        <div className="mt-8">
          <WhatsAppActivation />
        </div>

        <div className="p-6">
          {/* Welcome Video */}
          <div className="mb-12">
            <div className="aspect-video rounded-lg overflow-hidden bg-slate-100">
              <iframe
                width="100%"
                height="100%"
                src={steps[0].video}
                title="Tutorial ImóvelIA"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="mt-4 text-center">
              <button className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium">
                {steps[0].action.icon}
                {steps[0].action.text}
              </button>
            </div>
          </div>

          {/* Feature Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {steps.slice(1).map((step, index) => (
              <a
                key={index}
                href={step.link}
                className="block p-6 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors"
              >
                <div className="flex flex-col items-center text-center">
                  {step.icon}
                  <h3 className="font-semibold mt-4 mb-2">{step.title}</h3>
                  <p className="text-sm text-slate-600 mb-4">{step.description}</p>
                  <span className="inline-flex items-center gap-1 text-blue-600 text-sm font-medium">
                    Começar
                    <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-8 p-4 bg-yellow-50 rounded-lg">
            <p className="text-sm text-yellow-800">
              Precisa de ajuda? Entre em contato pelo WhatsApp e nossa equipe irá te auxiliar.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;